import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Checkbox } from "semantic-ui-react";

const DeleteClassModal = (props) => {
    const { t } = useTranslation();
    const { show, onClose, text, proceedTxt, cancelTxt, onProceed, title } = props;
    const [allClasses, setAllClasses] = useState(false);
    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>{text}</p>
                <Form.Group>
                    <Checkbox label={<label className="form-label">{t("schedule.makeChangeForAll")}</label>} checked={allClasses} onChange={() => setAllClasses(!allClasses)} />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={onClose}>
                    {cancelTxt}
                </Button>
                <Button variant="outline-primary" onClick={() => onProceed(allClasses)}>
                    {proceedTxt}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteClassModal;
